import React from "react";
import Banner from "../../components/Banner";
import { Sidebar } from "../../components/Sidebar";
import axios from "axios";
import Spinner from "../../components/Spinner";
import { Modal } from "../../components/Modal";
import { primaryLabelName, secondaryLabelName, uniqueIdentifier1Name, uniqueIdentifier2Name } from "../../utils/helper"

const API = localStorage.getItem("assethost");

export default class PublicAnnouncement extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      valid: false,
      msg: "",
      toastColor: "",
      announcements: [],
      currentPage: 0,
      totalPages: 1,
      pageSize: 10,

      announcementDetail: {},
      announcementId: undefined,
      readMore: false,

      // Announcement form fields
      showAddModal: false,
      category: "",
      subcategory: "",
      startDate: "",
      endDate: "",
      daysDuration: "",
      assetName1: "",
      assetName2: "",
      uniqueIdentifier1: "",
      uniqueIdentifier2: "",
      type: "",
      details: "",
      pictureFile: null,
      categories: [],
      subcategories: [],
      types: [],

      errors: {},
    };
    this.fetchAnnouncements = this.fetchAnnouncements.bind(this);
    this.fetchAnnouncementById = this.fetchAnnouncementById.bind(this);
  }

  componentDidMount() {
    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        loading: false,
        msg: "No User Token",
        toastColor: "danger",
      });
      sessionStorage.clear();
      window.location.href = `/?redirectUrl=${window.location.pathname + window.location.search
        }`;
      return;
    }
    this.fetchAnnouncements(token);
  }


  fetchAnnouncements(token, page = 0) {
    this.setState({ loading: true, msg: "", toastColor: "" });

    axios
      .get(API + `/announcement/getactive`, {
        headers: { Authorization: `Bearer ${token}` },
        params: {
          limit: this.state.pageSize,
          offset: page * this.state.pageSize,
        },
      })
      .then((response) => {
        let announcements = [];
        let totalPages = 1;
        if (Array.isArray(response.data)) {
          announcements = response.data;
          totalPages = Math.ceil(announcements.length / this.state.pageSize);
        } else if (
          response.data &&
          response.data.content &&
          Array.isArray(response.data.content)
        ) {
          announcements = response.data.content;
          totalPages = response.data.totalPages || 1;
        }
        this.setState({
          announcements,
          currentPage: page,
          totalPages,
          loading: false,
        });
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.location.href = `/?redirectUrl=${window.location.pathname + window.location.search
            }`;
        }
        this.setState({
          announcements: [],
          totalPages: 1,
          loading: false,
          msg:
            error?.response?.data?.message || "Failed to load announcements.",
          toastColor: "danger",
        });
      });
  }

  fetchAnnouncementById() {
    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        loading: false,
        msg: "No User Token",
        toastColor: "danger",
      });
      sessionStorage.clear();
      window.location.href = `/?redirectUrl=${window.location.pathname + window.location.search
        }`;
      return;
    }

    this.setState({ loading: true, msg: "", toastColor: "" });

    axios
      .get(API + `/announcement/getbyid/${this.state.announcementId}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        console.log("Announcement detail response:", response.data);
        this.setState({
          announcementDetail: response.data,
          loading: false,
        });
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.location.href = `/?redirectUrl=${window.location.pathname + window.location.search
            }`;
        }
        this.setState({
          announcementDetail: {},
          loading: false,
          msg:
            error?.response?.data?.message || "Failed to load announcements.",
          toastColor: "danger",
        });
      });
  }

  handleChange(e) {
    const { name, value } = e.target;

    if (name === "category") {
      const subcategories = this.state.categories.find(
        (cat) => Number(cat.id) === Number(value)
      ).subcategorys;
      this.setState(
        {
          category: value,
          subcategory: "",
          subcategories: subcategories,
        },
        this.validate
      );
    } else {
      this.setState({ [name]: value }, this.validate);
    }
  }
  render() {
    const s = this.state;
    let divMsg = null;
    if (s.msg) {
      divMsg = (
        <div
          className={
            s.toastColor === "success"
              ? "alert alert-success mx-7"
              : "alert alert-danger mx-7"
          }
        >
          {s.msg}
        </div>
      );
    }

    if (s.loading) {
      return <Spinner className="" />;
    }

    return (
      <div className="min-vh-100 d-flex justify-content-between bg-white">
        <Sidebar />
        <div className="min-vh-100 d-flex flex-column flex-grow-1">
          <Banner title="Public Announcement" />
          {divMsg}
          <div className="w-100 flex-grow-1 px-5 d-flex flex-column align-items-center justify-content-start">

            <div className="w-100 overflow-auto">
              <ul className="list-disc list-outside pl-4">
                {!!s.announcements?.length &&
                  s.announcements?.map((announcement) => (
                    <li className="list-item">
                      <b>{announcement.title}</b>
                      <div className="d-flex justify-content-between">
                        <button
                          className="text-blue-500 hover:text-blue-600 hover:underline italic"
                          onClick={() =>
                            this.setState(
                              {
                                announcementId: announcement.id,
                                readMore: true,
                              },
                              this.fetchAnnouncementById
                            )
                          }
                        >
                          Read more...
                        </button>
                        <div>{announcement.createdBy}</div>
                      </div>
                    </li>
                  ))}
              </ul>
              {s.announcements.length === 0 && (
                <div className="text-muted text-center py-4">
                  No announcements found.
                </div>
              )}
            </div>

            {s.totalPages > 1 && (
              <div className="d-flex justify-content-center align-items-center gap-2 mt-4">
                <button
                  className="btn btn-outline"
                  disabled={s.currentPage === 0}
                  onClick={() =>
                    this.fetchAnnouncements(
                      sessionStorage.getItem("token"),
                      s.currentPage - 1
                    )
                  }
                >
                  Previous
                </button>
                <span>
                  Page {s.currentPage + 1} of {s.totalPages}
                </span>
                <button
                  className="btn btn-outline"
                  disabled={s.currentPage + 1 >= s.totalPages}
                  onClick={() =>
                    this.fetchAnnouncements(
                      sessionStorage.getItem("token"),
                      s.currentPage + 1
                    )
                  }
                >
                  Next
                </button>
              </div>
            )}
          </div>

        </div>


        {s.readMore && (
          <Modal
            title="Announcement Details"
            closeAction={() => this.setState({ readMore: false })}
            footerContent={
              <>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() =>
                    this.setState({
                      readMore: false,
                      announcementId: undefined,
                      announcementDetail: {},
                    })
                  }
                >
                  Close
                </button>
              </>
            }
          >
            <div className="max-w-4xl mx-auto p-6">
              {/* Header Section */}
              <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded p-4 mb-4 border-start border-4 border-primary">
                <h2 className="fs-4 fw-bold text-dark mb-2">
                  {s.announcementDetail.title || "Announcement Details"}
                </h2>
                <div className="d-flex flex-wrap gap-3 text-muted small">
                  <div className="flex items-center gap-2">
                    <span className="font-medium">Created by:</span>
                    <span className="text-blue-600">
                      {s.announcementDetail.createdBy || "N/A"}
                    </span>
                  </div>
                  <div className="flex items-center gap-2">
                    <span className="font-medium">Type:</span>
                    <span
                      className={`px-2 py-1 rounded-full text-xs font-medium ${s.announcementDetail.announcementType === "LOST"
                          ? "bg-red-100 text-red-800"
                          : s.announcementDetail.announcementType === "STOLEN"
                            ? "bg-orange-100 text-orange-800"
                            : s.announcementDetail.announcementType === "RECOVERED"
                              ? "bg-green-100 text-green-800"
                              : "bg-gray-100 text-gray-800"
                        }`}
                    >
                      {s.announcementDetail.announcementType || "N/A"}
                    </span>
                  </div>
                  <div className="flex items-center gap-2">
                    <span className="font-medium">Asset Type:</span>
                    <span className="text-purple-600">
                      {s.announcementDetail.assetType || "N/A"}
                    </span>
                  </div>
                </div>
              </div>

              <div className="row g-4">
                {/* Asset Information Card */}
                {s.announcementDetail.assetType &&
                  <div className="col-12 col-lg-6 bg-white rounded shadow border p-4">
                    <h3 className="fs-5 fw-semibold text-dark mb-3 d-flex align-items-center gap-2">
                      <svg
                        className="w-5 h-5 text-primary"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                        />
                      </svg>
                      Asset Information
                    </h3>

                    <div className="space-y-3">
                      <div className="d-flex justify-content-between">
                        <span className="fw-medium text-muted">
                          {primaryLabelName(s.announcementDetail.assetType)}:
                        </span>
                        <span className="text-gray-800 text-right">
                          {s.announcementDetail.uniqueIdentifier1 || "N/A"}
                        </span>
                      </div>
                      <div className="flex justify-between items-start">
                        <span className="font-medium text-gray-600">
                          {secondaryLabelName(s.announcementDetail.assetType)}:
                        </span>
                        <span className="text-gray-800 text-right">
                          {s.announcementDetail.uniqueIdentifier2 || "N/A"}
                        </span>
                      </div>
                      <div className="flex justify-between items-start">
                        <span className="font-medium text-gray-600">
                          {uniqueIdentifier1Name(s.announcementDetail.assetType)}:
                        </span>
                        <span className="text-gray-800 text-right font-mono text-sm bg-gray-50 px-2 py-1 rounded">
                          {s.announcementDetail.uniqueIdentifier1 || "N/A"}
                        </span>
                      </div>
                      {s.announcementDetail.assetType === 'MOBILE' &&
                        <div className="flex justify-between items-start">
                          <span className="font-medium text-gray-600">
                            {uniqueIdentifier2Name(s.announcementDetail.assetType)}:
                          </span>
                          <span className="text-gray-800 text-right font-mono text-sm bg-gray-50 px-2 py-1 rounded">
                            {s.announcementDetail.uniqueIdentifier2 || "N/A"}
                          </span>
                        </div>}
                    </div>
                  </div>
                }
                {/* Details Card */}
                <div className="col-12 col-lg-6 bg-white rounded shadow border p-4">
                  <h3 className="fs-5 fw-semibold text-dark mb-3 d-flex align-items-center gap-2">
                    <svg
                      className="w-5 h-5 text-success"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                      />
                    </svg>
                    Announcement Details
                  </h3>

                  <div className="space-y-3">
                    <div>
                      <span className="font-medium text-gray-600 block mb-2">
                        Description:
                      </span>
                      <div className="text-gray-800 bg-gray-50 p-3 rounded-md min-h-[80px]">
                        {s.announcementDetail.detail ||
                          "No description available"}
                      </div>
                    </div>

                    {s.announcementDetail.contentType && (
                      <div>
                        <span className="font-medium text-gray-600 block mb-2">
                          Image:
                        </span>
                        <div className="bg-gray-50 p-3 rounded-md">
                          {s.announcementDetail.contentType === 'application/pdf' && <iframe title="File View" src={s.announcementDetail.fileData} type="application/pdf" style={{ width: 100 + '%', height: 500 + 'px' }}></iframe>}
                          {s.announcementDetail.contentType.includes('image') && <img title="File View" alt={s.announcementDetail.contentType} src={'data:' + s.announcementDetail.contentType + ';base64,' + s.announcementDetail.fileData} style={{ width: 100 + '%' }} />}
                          <div className="hidden text-gray-500 text-sm italic">
                            Image not available or failed to load
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* Additional Information */}
              {/* <div className="mt-6 bg-white rounded-lg shadow-md p-6 border border-gray-200">
                <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center gap-2">
                  <svg
                    className="w-5 h-5 text-purple-500"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                  Additional Information
                </h3>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm">
                  <div className="bg-blue-50 p-3 rounded-md">
                    <div className="font-medium text-blue-800">
                      Announcement ID
                    </div>
                    <div className="text-blue-600 font-mono">
                      {s.announcementDetail.id || "N/A"}
                    </div>
                  </div>
                  <div className="bg-green-50 p-3 rounded-md">
                    <div className="font-medium text-green-800">
                      Content Type
                    </div>
                    <div className="text-green-600">
                      {s.announcementDetail.contentType || "N/A"}
                    </div>
                  </div>
                  <div className="bg-purple-50 p-3 rounded-md">
                    <div className="font-medium text-purple-800">File Name</div>
                    <div
                      className="text-purple-600 truncate"
                      title={s.announcementDetail.fileName}
                    >
                      {s.announcementDetail.fileName || "N/A"}
                    </div>
                  </div>
                </div>
              </div> */}

              {/* Action Buttons */}
              {/* <div className="mt-6 flex justify-end gap-3">
                <button
                  className="btn btn-outline-secondary px-4 py-2 border border-gray-300 text-gray-700 hover:bg-gray-50 rounded-md transition-colors"
                  onClick={() => {
                    // You can add print functionality here if needed
                    window.print();
                  }}
                >
                  <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z"/>
                  </svg>
                  Print
                </button>
                <button
                  className="btn btn-primary px-4 py-2 bg-blue-600 text-white hover:bg-blue-700 rounded-md transition-colors"
                  onClick={() => {
                    // You can add share functionality here if needed
                    if (navigator.share) {
                      navigator.share({
                        title: s.announcementDetail.title,
                        text: s.announcementDetail.detail,
                        url: window.location.href,
                      });
                    }
                  }}
                >
                  <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.367 2.684 3 3 0 00-5.367-2.684z"/>
                  </svg>
                  Share
                </button>
              </div> */}
            </div>
          </Modal>
        )}
      </div>
    );
  }
}
